export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`) || [];

  return parts.length === 2 ? decodeURIComponent((parts.pop()?.split(";").shift()) || "") : null;
};

export const removeCookie = (name: string, path: string = "/") => {
  document.cookie = `${name}=; Path=${path}; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
};

export const setCrossSubdomainsCookie = async ({
  name,
  value,
  expInDays,
  domain
}: {
  name: string,
  value: any,
  expInDays?: number,
  domain: string
}) => {
  let expires = "";

  if (expInDays) {
    const date = new Date();
    const expInMs = expInDays * 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + expInMs);
    expires = "; expires=" + date.toUTCString();
  };

  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; domain=${domain}; SameSite=Lax`;
};